export type PublicCurrencyOption = {
  code: string;
  symbol: string;
  rate: number;
};

export const PUBLIC_CURRENCY_OPTIONS: PublicCurrencyOption[] = [
  { code: "ALL", symbol: "L", rate: 1 },
  { code: "EUR", symbol: "EUR", rate: 98 },
  { code: "GBP", symbol: "GBP", rate: 114 },
  { code: "USD", symbol: "$", rate: 90 },
];

export const convertFromAll = (value: number | null | undefined, targetCurrencyCode: string) => {
  const normalizedValue = Number(value ?? 0);
  const targetCurrency = PUBLIC_CURRENCY_OPTIONS.find((currency) => currency.code === targetCurrencyCode);
  const rate = targetCurrency?.rate && targetCurrency.rate > 0 ? targetCurrency.rate : 1;

  return normalizedValue / rate;
};

export const formatPublicPrice = (value: number | null | undefined, targetCurrencyCode: string, language = "en") => {
  const normalizedLanguage = language.toLowerCase();
  const localeByLanguage: Record<string, string> = {
    al: "sq-AL",
    en: "en-GB",
    it: "it-IT",
  };

  const converted = convertFromAll(value, targetCurrencyCode);
  const locale = localeByLanguage[normalizedLanguage] || "en-GB";

  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: targetCurrencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(converted);
  } catch {
    return `${converted.toFixed(2)} ${targetCurrencyCode}`;
  }
};
